import { render } from "./SiteFooter.vue?vue&type=template&id=0c293af1&scoped=true"
const script = {}

import "./SiteFooter.vue?vue&type=style&index=0&id=0c293af1&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c293af1"]])

export default __exports__